import { bookmarkStore } from '../../rootReducer';
import { bookmarks } from '../../reducers/Bookmark/bookmark.reducer';

export function selectBookmark(state) {
    return state[bookmarkStore][bookmarks];
}
